/** @jsx jsx */
import { css, jsx } from "@emotion/core"

function escapeRegExp(text: string) {
  return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}

/**
 * Renders `text` with every case insensitive occurrence of any word in `query` marked. Words are
 * matched separately (as the product search does), longest first so overlapping words mark the
 * longest match.
 */
export function HighlightedText({ text, query }: { text: string; query: string }) {
  const words = Array.from(new Set(query.trim().split(/\s+/).filter(Boolean))).sort(
    (a, b) => b.length - a.length,
  )
  if (words.length === 0 || !text) {
    return <span>{text}</span>
  }

  // splitting on a capture group puts the matches at the odd indexes
  const parts = text.split(new RegExp(`(${words.map(escapeRegExp).join("|")})`, "gi"))

  return (
    <span>
      {parts.map((part, index) =>
        index % 2 === 1 ? (
          <mark
            key={index}
            css={css`
              background: #fff0a8;
              color: inherit;
              border-radius: 2px;
              padding: 0 1px;
              margin: 0 -1px;
            `}
          >
            {part}
          </mark>
        ) : (
          part
        ),
      )}
    </span>
  )
}
